import { useEffect } from "react";
import axios, { setAuthToken } from "../../../service/auth/axios";
import { authData } from "../../../store/slice/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (res) => res,
            async (err) => {
                const status = err.response?.status;

                if ((status === 401 || status === 403) && location.pathname !== "/login") {
                    localStorage.removeItem("token");

                    dispatch(
                        authData({
                            user: null,
                            isLoading: false,
                            isAuthenticated: false,
                        })
                    );

                    navigate("/login");
                }

                return Promise.reject(err);
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [dispatch, navigate, location.pathname]);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token && location.pathname !== "/login") {
            dispatch(
                authData({
                    user: null,
                    isLoading: false,
                    isAuthenticated: false,
                })
            );
            navigate("/login");
            return;
        }

        if (token) {
            setAuthToken(token);
        }
    }, [dispatch, navigate, location.pathname]);

    return <>{children}</>;
};

export default AuthProvider;
